"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
const Link = _ref => {
  let {
    children,
    href,
    iconClass,
    iconPosition = "left",
    onItemClick,
    ariaLabel,
    ...rest
  } = _ref;
  return /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
    children: href ? /*#__PURE__*/(0, _jsxRuntime.jsxs)("a", {
      "aria-label": ariaLabel,
      href: href,
      ...rest,
      children: [iconClass && iconPosition == "left" ? /*#__PURE__*/(0, _jsxRuntime.jsx)("i", {
        className: "me-1 " + iconClass
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
        children: " "
      }), children, iconClass && iconPosition == "only" ? /*#__PURE__*/(0, _jsxRuntime.jsx)("i", {
        className: iconClass
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
        children: " "
      }), iconClass && iconPosition == "right" ? /*#__PURE__*/(0, _jsxRuntime.jsx)("i", {
        className: "ms-1 " + iconClass
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
        children: " "
      })]
    }) : /*#__PURE__*/(0, _jsxRuntime.jsxs)("a", {
      "aria-label": ariaLabel,
      onClick: onItemClick,
      ...rest,
      children: [iconClass && iconPosition == "left" ? /*#__PURE__*/(0, _jsxRuntime.jsx)("i", {
        className: "me-1 " + iconClass
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
        children: " "
      }), children, iconClass && iconPosition == "only" ? /*#__PURE__*/(0, _jsxRuntime.jsx)("i", {
        className: iconClass
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
        children: " "
      }), iconClass && iconPosition == "right" ? /*#__PURE__*/(0, _jsxRuntime.jsx)("i", {
        className: "ms-1 " + iconClass
      }) : /*#__PURE__*/(0, _jsxRuntime.jsx)(_jsxRuntime.Fragment, {
        children: " "
      })]
    })
  });
};
Link.propTypes = {
  href: _propTypes.default.string,
  text: _propTypes.default.string
};
Link.defaultProps = {};
var _default = exports.default = Link;